import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';
import { formatBytes, formatDuration } from '../../../utils/attachmentRules';

// One attachment in the edit form: a photo thumbnail, or a row for files and audio.
export const AttachmentChip = ({ item, url, onRemove }) => {
  const remove = (
    <button
      type="button"
      onClick={onRemove}
      aria-label={`Remove ${item.name}`}
      className="p-1.5 rounded-full bg-white/90 text-slate-600 shadow hover:text-red-600"
    >
      <SafeIcon icon={FiIcons.FiX} />
    </button>
  );

  if (item.kind === 'photo') {
    return (
      <div className="relative aspect-square overflow-hidden rounded-xl bg-slate-100">
        {url && <img src={url} alt={item.name} className="h-full w-full object-cover" />}
        <div className="absolute right-1 top-1">{remove}</div>
      </div>
    );
  }

  const isAudio = item.kind === 'audio';
  return (
    <div className="col-span-full rounded-xl border border-slate-200 bg-white p-3 space-y-2">
      <div className="flex items-center gap-3">
        <SafeIcon icon={isAudio ? FiIcons.FiMic : FiIcons.FiFile} className="text-slate-400 shrink-0" />
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-semibold text-slate-800">{item.name}</p>
          <p className="text-xs text-slate-400">
            {formatBytes(item.size)}
            {item.duration ? ` · ${formatDuration(item.duration)}` : ''}
          </p>
        </div>
        {remove}
      </div>
      {isAudio && url && <audio controls preload="none" src={url} className="w-full" />}
    </div>
  );
};